import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

// Options use { value, label }; callers put All/None entries before named choices.
const SearchableAdminSelect = ({ label, value, options, onChange, disabled = false, sx, clearValue = '' }) => (
  <Autocomplete
    options={options}
    value={options.find(option => option.value === value) || null}
    onChange={(_, option) => onChange(option?.value ?? clearValue)}
    getOptionLabel={option => option.label || ''}
    isOptionEqualToValue={(option, selected) => option.value === selected.value}
    autoHighlight
    openOnFocus
    disabled={disabled}
    fullWidth
    size="small"
    sx={sx}
    slotProps={{ popper: { sx: { zIndex: 'var(--z-modal-components)' } } }}
    renderInput={params => <TextField {...params} label={label} size="small" />}
  />
);

export default SearchableAdminSelect;
